// export const apiUrl = import.meta.env.DEV ? '/api' : 'https://api.cjkhtech.com';
export const apiUrl = import.meta.env.VITE_API_URL;